import { EncooFile } from "src/models/file";
import { createEntityModel } from "src/store/models/entity/_shared";

export const FileEntityModel = createEntityModel<EncooFile>();
